import { Level } from "../types/level";

export function getLevelStr(level: Level) {
  switch (level) {
    case Level.ADVANCED:
      return "پیشرفته";
    case Level.BEGINNER:
      return "مبتدی";
    case Level.MEDUIM:
      return "متوسط";
  }
}

export function toLevel(str: string) {
  switch (str) {
    case "پیشرفته":
      return Level.ADVANCED;
    case "مبتدی":
      return Level.BEGINNER;
    case "متوسط":
      return Level.MEDUIM;
    default:
      return null;
  }
}
